import { RadioButton } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { AqarmapProSourceEnum } from '~/constants/enums';
import PlanPrices from '~/pages/Subscription/Checkout/PlanPrices';
import { sendGTMEvent } from '~/utils';

export default function PlanOption({
  id,
  title,
  price,
  oldPrice,
  isSelected,
  showBadge = false,
  period,
  onPlanChange,
}: {
  id: number;
  title: string;
  price: string | number;
  oldPrice: string | number | null;
  isSelected: boolean;
  showBadge?: boolean;
  period: string;
  onPlanChange: (planId: number) => void;
}) {
  const { t } = useTranslation('app');

  return (
    <button
      type="button"
      onClick={() => {
        sendGTMEvent({
          event: 'gtm-aqarmap_pro',
          subscribe_source: AqarmapProSourceEnum.SUBSCRIPTION_CHECKOUT_TOGGLE,
        });

        if (!isSelected) {
          onPlanChange(id);
        }
      }}
      className={`relative flex flex-1 rounded-[16px]  px-2x py-1.5x ${
        isSelected ? 'bg-blue_light_2 text-blue' : 'bg-white text-gray__dark_2'
      }`}
    >
      <div className="flex w-full flex-col gap-0.5x">
        <div className="flex w-full gap-0.5x">
          <RadioButton
            size="small"
            wrapperClassName="!w-auto !flex-none !shrink-0"
            field={{
              id: `plan-toggle-${id}`,
              checked: isSelected,
              readOnly: true,
              tabIndex: -1,
              className: 'p-0.5x',
            }}
            label={{ text: '' }}
          />
          <div className="flex w-full justify-center">
            <p
              className={`text-caption-1 ${
                isSelected ? 'text-blue' : 'text-gray__dark_2'
              }`}
            >
              {title}
            </p>
            {showBadge && (
              <span className="absolute end-0 top-[-12px] rounded-[8px] bg-green_light px-x py-0.5x text-caption-3 text-white">
                {t('subscriptionSave50')}
              </span>
            )}
          </div>
        </div>
        <PlanPrices
          oldPrice={oldPrice}
          price={price}
          isSelected={isSelected}
          period={period}
        />
      </div>
    </button>
  );
}
